<lib-filter-list [configService]="hubspotContactListConfigService"></lib-filter-list>
